import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';

const MAANDEN = ['januari','februari','maart','april','mei','juni','juli','augustus','september','oktober','november','december'];
const iso = (d) => d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
const fmt = (d) => new Date(d).toLocaleDateString('nl-NL', { day: 'numeric', month: 'short' });
const STATUS = { aangevraagd: ['In behandeling', '#92400e', '#fef3c7'], actief: ['Goedgekeurd', '#065f46', '#d1fae5'], vervuld: ['Afgerond', '#374151', '#f3f4f6'] };

export default function InzetAgenda({ types }) {
  const [open, setOpen] = useState(true);
  const [typeId, setTypeId] = useState(null);
  const [maand, setMaand] = useState(() => { const d = new Date(); return new Date(d.getFullYear(), d.getMonth(), 1); });
  const [dagen, setDagen] = useState({});
  const [cap, setCap] = useState(0);
  const [res, setRes] = useState([]);
  const [selDag, setSelDag] = useState(null);

  useEffect(() => { if (!typeId && types && types.length) setTypeId(types[0].id); }, [types, typeId]);

  const laad = useCallback(() => {
    if (!typeId) return;
    const van = iso(maand), tot = iso(new Date(maand.getFullYear(), maand.getMonth() + 1, 0));
    api.get('/inzetmiddelen/agenda?type_id=' + typeId + '&van=' + van + '&tot=' + tot)
      .then(r => {
        const m = {}; (r.data.dagen || []).forEach(d => { m[String(d.dag).slice(0, 10)] = d; });
        setDagen(m); setCap(r.data.capaciteit || 0); setRes(r.data.reserveringen || []);
      }).catch(() => {});
  }, [typeId, maand]);
  useEffect(() => { laad(); }, [laad]);

  const eerste = new Date(maand.getFullYear(), maand.getMonth(), 1);
  const offset = (eerste.getDay() + 6) % 7;
  const nDagen = new Date(maand.getFullYear(), maand.getMonth() + 1, 0).getDate();
  const cellen = [];
  for (let i = 0; i < offset; i++) cellen.push(null);
  for (let d = 1; d <= nDagen; d++) cellen.push(iso(new Date(maand.getFullYear(), maand.getMonth(), d)));
  const vandaag = iso(new Date());
  const opDag = (dag) => res.filter(r => String(r.van_datum).slice(0, 10) <= dag && dag <= String(r.tot_datum).slice(0, 10));
  const type = (types || []).find(t => t.id === typeId) || {};

  return (
    <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, padding: '14px 16px', margin: '14px 0' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: open ? 10 : 0, flexWrap: 'wrap', gap: 8 }}>
        <h3 style={{ margin: 0, fontSize: 15, cursor: 'pointer' }} onClick={() => setOpen(!open)}>{open ? '▾' : '▸'} 📅 Agenda — {type.naam || ''}</h3>
        {open && (
          <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
            {(types || []).map(t => (
              <button key={t.id} className="inzet-btn-light" onClick={() => { setTypeId(t.id); setSelDag(null); }} style={{ fontWeight: t.id === typeId ? 700 : 400, borderColor: t.id === typeId ? '#059669' : undefined }}>{t.naam}</button>
            ))}
          </div>
        )}
      </div>
      {open && (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
              <button className="inzet-btn-light" onClick={() => { setMaand(new Date(maand.getFullYear(), maand.getMonth() - 1, 1)); setSelDag(null); }}>← Vorige</button>
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontWeight: 700 }}>{MAANDEN[maand.getMonth()]} {maand.getFullYear()}</div>
                <div style={{ fontSize: 12, color: '#6b7280' }}>voorraad {cap} · cijfer = vrij per dag</div>
              </div>
              <button className="inzet-btn-light" onClick={() => { setMaand(new Date(maand.getFullYear(), maand.getMonth() + 1, 1)); setSelDag(null); }}>Volgende →</button>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: selDag ? '1fr 300px' : '1fr', gap: 14 }}>
              <div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7,1fr)', gap: 4, marginBottom: 4 }}>
                  {['ma','di','wo','do','vr','za','zo'].map(d => <div key={d} style={{ textAlign: 'center', fontSize: 11, color: '#6b7280' }}>{d}</div>)}
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7,1fr)', gap: 4 }}>
                  {cellen.map((dag, i) => {
                    if (!dag) return <div key={'x' + i} />;
                    const d = dagen[dag]; const vrij = d ? d.vrij : null; const n = opDag(dag).length;
                    let bg = '#f3f4f6', fg = '#374151';
                    if (vrij != null) { if (vrij <= 0) { bg = '#fee2e2'; fg = '#991b1b'; } else if (vrij <= Math.max(2, Math.ceil(cap * 0.2))) { bg = '#fef3c7'; fg = '#92400e'; } else { bg = '#d1fae5'; fg = '#065f46'; } }
                    const sel = selDag === dag;
                    return (
                      <button key={dag} type="button" onClick={() => setSelDag(sel ? null : dag)}
                        style={{ padding: '6px 4px', minHeight: 56, borderRadius: 8, border: '2px solid ' + (sel ? '#059669' : (dag === vandaag ? '#93c5fd' : 'transparent')), background: bg, cursor: 'pointer', textAlign: 'left' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, color: fg }}><span>{parseInt(dag.slice(8), 10)}</span>{n > 0 && <span>{n}×</span>}</div>
                        <div style={{ fontSize: 16, fontWeight: 700, color: fg, textAlign: 'center' }}>{vrij != null ? vrij : '·'}</div>
                      </button>
                    );
                  })}
                </div>
                <div style={{ fontSize: 11, color: '#6b7280', marginTop: 8 }}>groen = ruim vrij · oranje = bijna vol · rood = vol · n× = aantal reserveringen die dag · klik een dag voor details</div>
              </div>

              {selDag && (
                <div style={{ borderLeft: '1px solid #e5e7eb', paddingLeft: 14 }}>
                  <div style={{ fontWeight: 700, marginBottom: 8 }}>{new Date(selDag).toLocaleDateString('nl-NL', { weekday: 'long', day: 'numeric', month: 'long' })}</div>
                  {opDag(selDag).length === 0 && <div style={{ fontSize: 13, color: '#6b7280' }}>Geen reserveringen.</div>}
                  {opDag(selDag).map(r => {
                    const st = STATUS[r.status] || [r.status, '#374151', '#f3f4f6'];
                    return (
                      <div key={r.id} style={{ border: '1px solid #e5e7eb', borderRadius: 8, padding: '8px 10px', marginBottom: 8, fontSize: 13 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 6 }}>
                          <b>#{r.id} · {r.aantal}x</b>
                          <span style={{ fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 999, color: st[1], background: st[2] }}>{st[0]}</span>
                        </div>
                        <div>{r.partij_naam ? r.partij_naam + ' · ' : ''}{r.aanvrager_naam || r.aangevraagd_naam || '—'}</div>
                        <div style={{ color: '#6b7280' }}>{r.locatie_adres || r.bestemming || '—'}</div>
                        <div style={{ color: '#6b7280', fontSize: 12 }}>{fmt(r.van_datum)} t/m {fmt(r.tot_datum)}</div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
        </div>
      )}
    </div>
  );
}
